import React from 'react'
import { observer } from 'mobx-react-lite'

import { PrintFileCell } from './PrintFileCell'

import { useApi } from '../hooks/storeHook'

import { MyRowProps } from '../types/tableTypes'
import { PrintFileGroupModel } from '../server/mpsklad_core/Models/PrintFileGroupModel'

export const WbFileCell =
  observer(({row}: MyRowProps<PrintFileGroupModel>) => {
    const api = useApi()

    return <PrintFileCell
      row={row}
      makeLabelsUrl={api.label.wbLabelsFileUrl}
      makePurchaseListUrl={api.label.wbPurchaseListFileUrl}
      makeMsBarcodesUrl={api.label.wbMsBarcodesFileUrl}/>
  })